(ns dre.panels.author.views
  (:require
   ["antd" :refer [Spin Row Col Divider]]
   [clojure.string :as str]
   [dre.components.list :refer [collapsable-list]]
   [dre.components.search-results.views.article :refer [content-no-abstract]]
   [dre.components.subject :as subject]
   [dre.components.table :refer [table]]
   [dre.i18n.views :refer [tr]]
   [dre.panels.author.events :as events]
   [dre.widgets.authors.events :refer [author-capitalize]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name
  :author-details)

(defn top-subjects
  [interests]
  [collapsable-list
   (mapv (fn [item]
           (let [first-group (first item)
                 first-phrase (:phrase first-group)]
             {:content (r/as-element [subject/phrase first-phrase nil :hide-controls? true :href? true])})) interests)
   3])

(defn author-details-title
  [params]
  (let [human-name (author-capitalize
                    (get-in params [:author/author :author/name]))]
    [:h3 [tr human-name]]))

(defn author-details-content
  [details params]
  (let [{:keys
         [:author/affiliations :author/emails :author/orcid
          :author/coauthors :interests :interventions
          :author/bibliography]} details]
    [:div {:style {:width "100%"}}
    ;;  Emails
     (when (seq emails)
       [:<>
        [:> Row
         {:gutter 16}
         [:> Col
          {:span 4}
          [:b [tr "Emails"]]]
         [:> Col
          {:span 20}
          (interpose
           ", "
           (map
            (fn [e] ^{:key e}
              [:a {:href (str "mailto:" e)} e])
            emails))]]
        [:> Divider]])
    ;;  Orcid
     (when orcid
       [:<>
        [:> Row
         {:gutter 16}
         [:> Col
          {:span 4}
          [:b [tr "ORCID"]]]
         [:> Col
          {:span 20}
          [:a {:target "_blank"
               :rel "noopener noreferrer"
               :href (str events/orcid-uri orcid)} orcid]]]
        [:> Divider]])
    ;; key interests
     [:> Row
      {:gutter 16}
      [:> Col
       {:span 4}
       [:b [tr "Key interests"]]]
      [:> Col
       {:span 20}
       [top-subjects interests]]]
     [:> Divider]
     ;; Top interventions
     [:> Row
      {:gutter 16}
      [:> Col
       {:span 4}
       [:b [tr "Top interventions"]]]
      [:> Col
       {:span 20}
       [top-subjects interventions]]]
     [:> Divider]
    ;; Affiliations 
     (when (seq affiliations)
       [:<>
        [:> Row
         {:gutter 16}
         [:> Col
          {:span 4}
          [:b [tr "Affiliations"]]]
         [:> Col
          {:span 20}
          [collapsable-list
           (mapv (fn [{:keys [:affiliation/name
                              :affiliation/years]}]
                   (let [years (map vector years (map - (range)))
                         ranges (partition-by
                                 (fn [[y o]]
                                   (- (js/Number y) o)) years)
                         ranges (map #(if (< 1 (count %))
                                        (str (first (first %)) "-"
                                             (first (last %)))
                                        (first (first %))) ranges)]
                     {:content (r/as-element [:span [:span
                                           (str/join ", " ranges)] [:br] name])})) affiliations)
           3]]]
        [:> Divider]])
     ;; Recent bibliography
     [:> Row
      {:gutter 16}
      [:> Col
       {:span 4}
       [:b [tr "Recent bibliography"]]]
      [:> Col
       {:span 20}
       [collapsable-list
        (mapv (fn [article]
                {:content (r/as-element [:<>
                                         [:div {:class :results-article
                                                :style {:padding-bottom "0px"}}
                                          [:div
                                           {:class [(bem/be :results-article :col-content-no-abstract)]}
                                           [content-no-abstract article]]]])}) bibliography)
        3]]]
     [:> Divider]
     ;; Co-authors
     [:> Row
      {:gutter 16}
      [:> Col
       {:span 4}
       [:b [tr "Co-authors"]]]
      [:> Col
       {:span 20}
       [table
        {:columns [{:title [tr "Name"]
                    :render (fn [coauthor]
                              (author-capitalize (:author/name coauthor)))}
                   {:title [tr "Published together"]
                    :render (fn [coauthor]
                              (:author/coauthor-freq coauthor))}]
         :dataSource coauthors
         :pagination {:defaultPageSize 10
                      :hideOnSinglePage true}}]]]]))

(defn view
  []
  (let [state @(rf/subscribe [::events/state])
        status (:state state)
        loading? (or (:details-loading? status)
                     (:cooccurrences-loading? status)
                     (:bibliography-loading? status))
        details (merge (get-in state [:data :bibliography])
                       (get-in state [:data :author])
                       (get-in state [:data :details]))
        params (:params state)]
    [:div
     {:style {:width "90%"
              :height "100%"}}
     (if loading?
       [:div {:class (bem/be component-name :loading)}
        [:> Spin]]
       [:<>
        [:div {:style {:padding-bottom "2rem"}}
         [author-details-title params]]
        [:div 
         [author-details-content details params]]])]))
